<template lang='pug'>
  i.svg-icon.svg-icon-refresh
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d="M28.793,50.052h-5.146V50.01c0-14.335,11.438-26.397,26.026-26.329c7.111,0.032,13.645,2.906,18.3,7.603 l8.493-8.192c-6.856-6.915-16.33-11.189-26.793-11.189c-20.909,0-37.859,17.073-37.888,38.145H6.58c-3.19,0-4.494,2.132-2.899,4.744 l11.107,11.009c2.203,2.203,3.528,2.271,5.799,0L31.693,54.79C33.288,52.181,31.981,50.052,28.793,50.052z")
      path(d="M96.216,45.468L85.108,34.482c-2.265-2.265-3.667-2.13-5.797,0L68.206,45.468 c-1.595,2.606-0.294,4.738,2.896,4.738h5.139C76.158,64.448,64.758,76.403,50.22,76.337c-7.109-0.03-13.639-2.897-18.301-7.592 l-8.492,8.181c6.859,6.903,16.332,11.172,26.793,11.172c20.844,0,37.747-16.949,37.883-37.889h5.214 C96.509,50.206,97.81,48.071,96.216,45.468z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>